/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoices_DescriptionInputs */

const es_billing_invoices_description = /** @type {(inputs: Billing_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargá facturas de períodos anteriores.`)
};

const en_billing_invoices_description = /** @type {(inputs: Billing_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download invoices from previous periods.`)
};

/**
* | output |
* | --- |
* | "Download invoices from previous periods." |
*
* @param {Billing_Invoices_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_invoices_description = /** @type {((inputs?: Billing_Invoices_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoices_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_invoices_description(inputs)
	return en_billing_invoices_description(inputs)
});
export { billing_invoices_description as "billing.invoices.description" }